import { Box, Typography, Checkbox, Grid, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import KenButton from '../../../GlobalComponents/KenButton';
import { useTheme } from '@mui/material/styles';
import { useStyles } from '../styles';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';

const Filters = (props: any) => {
  const theme = useTheme();
  const classes = useStyles();
  const is1700 = useMediaQuery('(min-width:1700px)');
  const { handleClose, jobFilterData, selectedValues, setSelectedValues, handleDropDownChange, modalLeft, fromJobsViewAll } = props;
  console.log(selectedValues, 'selectedValues');

  const style = {
    position: 'absolute' as 'absolute',
    top: { xs: '50%', sm: '50%', xl:is1700?"55%": "59%" },
    left: modalLeft || { xs: '50%', sm: '50%', xl: is1700?"89.5%":"87%" },
    transform: 'translate(-50%, -50%)',
    width: { md: '280px', lg: '280px', xl: '280px', xs: '300px' },
    height: fromJobsViewAll ? '450px' : '68vh',
    // overflowY: 'auto',
    [theme.breakpoints.up('xxl')]: {
      height: fromJobsViewAll ? '567px' : '68vh',
    },
    [theme.breakpoints.down('sm')]: {
      height: '67vh',
      overflow: 'hidden'
    },
    bgcolor: 'background.paper',
    // boxShadow: 5,
    border: '1px solid #E0E0E0',
    borderRadius: '12px',
    pt: 3,
    pl: 3,
    pb: 3,
  };

  const handleChange = (event: any, index: string) => {
    const { value } = event.target;

    const selectedValue = Array.isArray(value) ? value : [value];

    console.log('index', event, index);

    if (index === 'Salary') {
      const salaryRanges = selectedValue
        .map((range: string) => {
          const salaryRange = range.replace(' LPA', '').split('-');
          if (salaryRange.length === 2) {
            return {
              start: parseInt(salaryRange[0]),
              end: parseInt(salaryRange[1]),
            };
          } else {
            console.error('Invalid salary range format', salaryRange);
            return null;
          }
        })
        .filter(Boolean);

      setSelectedValues((prevValues: any) => ({
        ...prevValues,
        Salary_Start_Range__c: salaryRanges.map((range: any) => range.start),
        Salary_End_Range__c: salaryRanges.map((range: any) => range.end),
        [index]: selectedValue,
      }));
    } else {
      setSelectedValues((prevValues: any) => ({
        ...prevValues,
        [index]: selectedValue,
      }));
    }
  };

  console.log('selectedValues23', selectedValues, jobFilterData);

  const data = [
    {
      title: 'Job title',
      key: 'Job_Title__c',
      value: jobFilterData.jobTitles,
    },
    {
      title: 'Company',
      key: 'Organization__r.Name',
      value: jobFilterData.companies,
    },
    {
      title: 'Workplace type',
      key: 'Work_Place_Type__c',
      value: ['Remote', 'Onsite', 'Hybrid'],
    },
    {
      title: 'Posted by',
      key: 'Posted_by',
      value: ['Anyone', 'myself'],
    },
    {
      title: 'Job location',
      key: 'Location__c',
      value: jobFilterData.locations,
    },
    {
      title: 'Posted On',
      key: 'Posted On',
      value: ['Anytime', 'Past Month', 'Past week', 'Past 24 hours'],
    },
    {
      title: 'Job type',
      key: 'Job_Type__c',
      value: jobFilterData.jobTypes,
    },
    {
      title: 'Salary',
      key: 'Salary',
      value: jobFilterData.salaryRanges,
    },
    {
      title: 'Skills',
      key: 'Skill_Required__c',
      value: jobFilterData.skills,
    },
  ];
  return (
    <div>
      <Box sx={style}>
        <Grid container>
          <Grid item xs={10}>
            <Typography sx={{ fontSize: '15px', fontWeight: 600 }}>Filters</Typography>
          </Grid>
          <Grid item xs={2}>
            <CloseIcon onClick={handleClose} />
          </Grid>
        </Grid>
        <Box className={`${classes.filterBox} scrollbar-cusgray`} style={
          fromJobsViewAll
            ? undefined
            : { height: is1700 ? '55vh' : '50vh', overflowY: 'auto' }
        }>
          {data?.map((val: any, index) => (
            <Box sx={{ width: '100%', mt: 3 }} key={index}>
              <FormControl fullWidth>
                <InputLabel id={`select-label-${index}`} sx={{ fontSize: '12px', fontWeight: 500 }}>
                  {val.title}
                </InputLabel>
                <Select
                  labelId={`select-label-${index}`}
                  id={`select-${index}`}
                  multiple
                  value={selectedValues[val.key] || []}
                  label={<Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{val.title}</Typography>}
                  onChange={(event) => handleChange(event, val.key)}
                  sx={{
                    height: '45px',
                    width: '93%',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF',
                    },
                  }}
                  renderValue={(selected) => selected?.join(', ')}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 300,
                        width: 200,
                      },
                    },
                  }}
                >
                  {val?.value?.map((option: string, optionIndex: number) => {
                    const isChecked = selectedValues[val.key]?.includes(option);
                    console.log(`Option: ${option}, Key: ${val.key}, IsChecked: ${isChecked}, SelectedValues for this key:`, selectedValues[val.key]);

                    return (
                      <MenuItem
                        key={optionIndex}
                        value={option}
                        sx={{
                          height: '50px',
                          width: '100%',
                          padding: '10px',
                          fontSize: '14px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Checkbox
                          checked={isChecked}
                          sx={{
                            marginRight: 1,
                            padding: 0,
                          }}
                        />
                        {option}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          ))}
        </Box>
        <hr />
        <Box sx={{ display: 'flex', justifyContent: 'end', pr: 3, paddingBottom: 3 }}>
          <KenButton
            variant="text"
            sx={{
              borderRadius: '8px',
              fontweight: 500,
              backgroundColor: 'none',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              color: 'black',
              width: 80,
            }}
            onClick={() => { setSelectedValues([]) }}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#373A45' }}>Clear</Typography>
          </KenButton>
          {/* <KenButton
            variant="text"
            sx={{
              borderRadius: '8px',
              fontweight: 500,
              backgroundColor: 'none',
              '&:hover': {
                backgroundColor: 'transparent',
              },
              color: 'black',
              width: 80,
            }}
            onClick={handleClose}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#373A45' }}>Cancel</Typography>
          </KenButton> */}
          <KenButton
            variant="contained"
            onClick={() => {
              handleDropDownChange(selectedValues);
              handleClose();
              // setSelectedValues([]);
            }}
            style={{
              width: 100,

              borderRadius: '7px',
              boxShadow: 'none',
              '& hover': {
                boxShadow: 'none',
              },
            }}
            fullWidth
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#5B4200' }}>Apply</Typography>
          </KenButton>
        </Box>
      </Box>
    </div>
  );
};

export default Filters;